import { Card, CardContent, Typography, Avatar, IconButton, Grid, Box, Container } from "@mui/material";
import { alpha } from '@mui/material/styles';
import { brand } from '../../getTheme';
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import { motion } from "framer-motion";

const teamMembers = [
    {
        name: "Claus Sønderstrup",
        role: "Founder",
        image: "",
        linkedin: "https://www.linkedin.com/in/claussonderstrup/",
        twitter: "",
    }
];

const OurTeam = () => {
    return (
        <Box className="standard-section" sx={{ py: 2 }}>
            <Container>
                <motion.div
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <Typography
                            variant="h4"
                            className="standard-heading"
                        align="center"
                        gutterBottom
                        color="text.primary"
                        sx={{ mb: 1 }} // Professional dark blue-gray color
                    >
                        Meet Our Team
                    </Typography>

                    <Typography
                        color="text.secondary"
                            variant="body1"
                            className="standard-body"
                        align="center"
                        sx={{ maxWidth: "750px", mx: "auto", fontWeight: 400 }}
                    >
                        Experts in cloud security and automation, committed to helping you safeguard and streamline your cloud environment.
                    </Typography>
                </motion.div>
                <Grid container spacing={4} justifyContent="flex-start" wrap="wrap" paddingTop={2} paddingBottom={2}>
                    {teamMembers.map((member, index) => (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                            <motion.div
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.5, delay: index * 0.2 }}
                            >
                                <Card
                                    sx={{
                                        textAlign: "center",
                                        p: 0,
                                        borderRadius: "16px",
                                        boxShadow: 3,
                                        minHeight: 420,
                                        transition: "transform 0.3s ease-in-out",
                                        "&:hover": {
                                            transform: "translateY(-10px)",
                                            boxShadow: 6,
                                        },
                                    }}
                                >
                                    {/* Member photo */}
                                    <Box sx={{
                                        position: "relative",
                                        width: "100%",
                                        maxWidth: "250px",
                                        aspectRatio: "1 / 1",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: "50%", // Maintain circular shape
                                        mx: "auto", // Center horizontally
                                    }}>
                                        {member.image ? (<Avatar
                                            src={member.image || ""}
                                            alt={member.name}
                                            sx={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: member.image ? "cover" : "contain", // Ensure proper image fitting
                                                borderRadius: "50%", // Make it a circle
                                                backgroundColor: member.image ? "transparent" : alpha(brand[50], 0.7),
                                                fontSize: "2rem",
                                                fontWeight: "bold",
                                                color: "black",
                                            }}
                                        />
                                        ) : (
                                            <Avatar
                                                sx={{
                                                    width: "80%",
                                                    height: "80%",
                                                    borderRadius: "50%",
                                                    backgroundColor: alpha(brand[50], 0.7),
                                                    fontSize: "2rem",
                                                    fontWeight: "bold",
                                                    color: "black",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                {member.name.charAt(0)}
                                            </Avatar>
                                        )}
                                    </Box>
                                    {/* Member name & designation */}
                                    <CardContent sx={{ padding: 2 }}>
                                        <Typography variant="h6" fontWeight="bold" gutterBottom color="text.primary">
                                            {member.name}
                                        </Typography>
                                        {/* Creative role title with blue color */}
                                        <Typography
                                            variant="body1"
                                            color="text.secondary"
                                            sx={{
                                                textTransform: "uppercase",
                                                letterSpacing: "0.5px",
                                                fontWeight: 300
                                            }}
                                        >
                                            <span role="img" aria-label="role">💼</span> {member.role}
                                        </Typography>
                                        {/* Social media buttons */}
                                        <Box sx={{ mt: 3, display: "flex", justifyContent: "center", gap: 2 }}>
                                            {member.linkedin && member.linkedin.trim() !== "" && (
                                                <IconButton
                                                    color="primary"
                                                    href={member.linkedin}
                                                    sx={{
                                                        fontSize: 32,
                                                        backgroundColor: 'primary.main',
                                                        borderRadius: "50%",
                                                        padding: 1,
                                                        transition: "all 0.3s ease",
                                                        "&:hover": {
                                                            backgroundColor: 'primary.dark',
                                                            transform: "scale(1.1)",
                                                        },
                                                    }}
                                                >
                                                    <LinkedInIcon sx={{ color: "white" }} />
                                                </IconButton>
                                            )}

                                            {member.twitter && member.twitter.trim() !== "" && (
                                                <IconButton
                                                        color="secondary"
                                                        href={member.twitter}
                                                        sx={{
                                                            fontSize: 32,
                                                            backgroundColor: 'secondary.main',
                                                        borderRadius: "50%",
                                                        padding: 1,
                                                        transition: "all 0.3s ease",
                                                        "&:hover": {
                                                                backgroundColor: 'secondary.dark',
                                                            transform: "scale(1.1)",
                                                        },
                                                    }}
                                                >
                                                    <TwitterIcon sx={{ color: "white" }} />
                                                </IconButton>
                                            )}
                                        </Box>
                                    </CardContent>
                                </Card>
                            </motion.div>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default OurTeam;
